// import AssignTerritoriesContainer from "./AssignTerritories";
// import TerritoriesContainer from "./Territories";
// import TerritoryRulesContainer from "./TerritoryRules";
import React from 'react';

const AssignTerritoriesContainer = React.lazy(() => import('./AssignTerritories'));
const TerritoriesContainer = React.lazy(() => import('./Territories'));
const TerritoryRulesContainer = React.lazy(() => import('./TerritoryRules'));


export {
    TerritoriesContainer,
    TerritoryRulesContainer,
    AssignTerritoriesContainer
};
